import { useMutation } from '@apollo/client/react';
import Cookies from 'js-cookie';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { calcShipDates } from '../../helpers/calcShipDate.js';

const SHOPIFY_CART_CLEAR_COOKIE = 'shopifyCartClearCookie';

import {
  applyDiscount,
  cartLinesRemove,
  cartLinesUpdate,
  checkoutCompleteErrorEffect,
  useCheckoutEffect
} from '../../graphql/checkoutQuery';

import LineItem from '../LineItem/index';
import CartPortal from "./CartPortal";

import { CartOpenContext } from "../../context/CartOpenContext";
import { CartContext } from "../../context/CheckoutContext";
import { checkoutAnalytics } from '../../helpers/analytics.js';
import { calculateSubtotal, calculateTotalDiscount, formatDecimalPrice } from "../../helpers/discount";

function Cart(props) {

  const { cartState, createCartLoading, resetToNewCart } = useContext(CartContext);
  const [cart, setCart] = cartState;
  const [discountCode, setDiscountCode] = useState('');

  const [isCartOpen, setCartOpen] = useContext(CartOpenContext);

  const [lineItemUpdateMutation,
    {
      data: lineItemUpdateData,
      loading: lineItemUpdateLoading,
      error: lineItemUpdateError
    }] = useMutation(cartLinesUpdate);

  const [lineItemRemoveMutation,
    {
      data: lineItemRemoveData,
      loading: lineItemRemoveLoading,
      error: lineItemRemoveError
    }] = useMutation(cartLinesRemove);

  checkoutCompleteErrorEffect(lineItemUpdateError, resetToNewCart);
  checkoutCompleteErrorEffect(lineItemRemoveError, resetToNewCart);

  useCheckoutEffect(lineItemUpdateData, 'cartLinesUpdate', setCart, resetToNewCart);
  useCheckoutEffect(lineItemRemoveData, 'cartLinesRemove', setCart, resetToNewCart);

  const updateLineItemInCart = (lineItemId, quantity) => {
    const variables = { cartId: cart.id, lines: [{ id: lineItemId, quantity: parseInt(quantity, 10) }] };
    lineItemUpdateMutation({ variables });
  };

  const removeLineItemInCart = (lineItemId) => {
    const variables = { cartId: cart.id, lineIds: [lineItemId] };
    lineItemRemoveMutation({ variables });
  };

  const [applyDiscountMutation,
    {
      data: applyDiscountData,
      loading: applyDiscountLoading,
      error: applyDiscountError
    }] = useMutation(applyDiscount);

  useCheckoutEffect(applyDiscountData, 'cartDiscountCodeApply', setCart, resetToNewCart);

  const onDiscountApply = () => {
    setDiscountCode('');
    const variables = { cartId: cart.id, discountCode };
    applyDiscountMutation({ variables });
  };

  const waitForCartConfirmCookie = () => {
    // start listening for cookie
    let found = false;
    const ref = setInterval(() => {
      const clearCookie = Cookies.get(SHOPIFY_CART_CLEAR_COOKIE)

      if (clearCookie) {
        // cookie removed before window refresh in clear listener, in apollo cache
        clearTimeout(ref);
        resetToNewCart();
      }
    }, 500)
  };

  const openCheckout = () => {
    window.open(cart.checkoutUrl);
    waitForCartConfirmCookie();
    checkoutAnalytics(cart);
  }

  let line_items = cart.lines.edges.map((line_item) => {
    return (
      <LineItem
        removeLineItemInCart={removeLineItemInCart}
        updateLineItemInCart={updateLineItemInCart}
        key={line_item.node.id.toString()}
        line_item={line_item.node}
      />
    );
  });

  const discount = calculateTotalDiscount(cart.lines.edges);

  const subTotal = formatDecimalPrice(calculateSubtotal(cart.lines.edges));

  const totalQuantity = line_items.length;

  const prevQuantityRef = useRef(totalQuantity);
  useEffect(() => {
    if (prevQuantityRef.current > 0 && totalQuantity === 0) {
      setCartOpen(false);
    }
    prevQuantityRef.current = totalQuantity;
  }, [totalQuantity]);

  if (createCartLoading) return <div className="Cart"></div>;

  const shipDates = calcShipDates(SHOPIFY_RAILS_SHIP_TIMES, cart.lines.edges);

  const totalPrice = cart.cost?.totalAmount ? formatDecimalPrice(cart.cost.totalAmount.amount) : 0;

  console.log(`iHDHHDHD totalQuantity: ${totalQuantity}`);
  console.log(`isCartOpen: ${isCartOpen}`);
  console.log(`totalQuantity > 0: ${totalQuantity > 0}`);
  console.log(`isCartOpen && totalQuantity > 0: ${isCartOpen && totalQuantity > 0}`);
  console.log(`Cart--open: ${isCartOpen && totalQuantity > 0 ? 'Cart--open' : ''}`);
  console.log(`Cart: ${isCartOpen && totalQuantity > 0 ? 'Cart--open' : ''}`);
  console.log(`Cart: ${isCartOpen && totalQuantity > 0 ? 'Cart--open' : ''}`);

  return (
    <React.Fragment>
      <div className={`Cart ${isCartOpen && totalQuantity > 0 ? 'Cart--open' : ''}`}>
        <header className="Cart__header">
          <h2>Your Cart</h2>
          <button
            onClick={() => setCartOpen(false)}
            className="Cart__close">
            ×
          </button>
        </header>
        <div className="Cart__line-items-cont">
          <ul className="Cart__line-items">
            {line_items}
          </ul>
        </div>
        <div className="Cart__footer">
          <div className="Cart-info clearfix">
            <div className="Cart-info__total">SubTotal</div>
            <div className="Cart-info__pricing">
              <span className="total-pricing">{totalPrice}</span>
            </div>
          </div>
          {lineItemUpdateLoading || lineItemRemoveLoading
            ? <button className="Cart__checkout btn btn-primary btn-light" disabled="disabled">CHECKOUT</button>
            : <button className="Cart__checkout btn btn-primary btn-light" onClick={openCheckout}>CHECKOUT</button>
          }
        </div>
      </div>
      <CartPortal
        isCartOpen={isCartOpen}
        setCartOpen={setCartOpen}
        appendId="cart-btn-cont"
        quantity={totalQuantity}
      />
    </React.Fragment>
  );
}

export default Cart;
